/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getSrpSystemCodeCodeInfo,
  postSrpSystemCodeInfo,
  deleteSrpSystemCodeInfo,
} from 'api/pgads.js'
import { Input, Button } from 'antd'

import CommonScreen from './CommonScreen'

const headers = [
  strCol({
    ident: 'srpSystemcode',
    display: 'System Code',
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'unitcode',
    display: 'Unit Code',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 450,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getSrpSystemCodeCodeInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postSrpSystemCodeInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteSrpSystemCodeInfo(apiTargetInfo)(data)

const title = 'System Code Management'

// const defaultData = {}

const SystemCodeManagement = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ textAlign: 'right' }}>System Code : </td>
            <td>
              <Input
                value={insertData.srpSystemcode}
                onChange={e =>
                  setInsertData({
                    ...insertData,
                    srpSystemcode: e.target.value,
                  })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Unit Code : </td>
            <td>
              <Input
                value={insertData.unitcode}
                onChange={e =>
                  setInsertData({ ...insertData, unitcode: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Description : </td>
            <td colSpan={6}>
              <Input
                value={insertData.description}
                onChange={e =>
                  setInsertData({ ...insertData, description: e.target.value })
                }
              />
            </td>

            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && insertComp}
      insertCompHeight={100}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SystemCodeManagement)
